<template>
  <article>
    <custom-callout
      v-for="(alternativeLocation, index) in alternativeLocationList"
      :key="index"
      :has-toggle="false"
      class="mt-2 mb-3"
    >
      <div class="container-fluid">
        <div class="row">
          <div class="col-6 col-md-4 mb-2 mb-md-0">
            <span class="box-result-field-label">
              Categoría de la Alternativa:
            </span>
            <br />
            <span class="box-result-field-value">
              {{ alternativeLocation.category || '-' }}
            </span>
          </div>
          <div class="col-6 col-md-4 mb-2 mb-md-0">
            <span class="box-result-field-label">
              Nombre de la Alternativa:
            </span>
            <br />
            <span class="box-result-field-value">
              {{ alternativeLocation.alternative || '-' }}
            </span>
          </div>
          <div class="col-6 col-md-4 mb-2 mb-md-0">
            <span class="box-result-field-label">Nombre del Maestro:</span>
            <br />
            <span class="box-result-field-value">
              {{ alternativeLocation.teacher || '-' }}
            </span>
          </div>
        </div>
      </div>
    </custom-callout>
  </article>
</template>

<script>
import CustomCallout from 'custom-callout';
import { getSchoolAlternativeLocations } from '@/modules/alternative-location-management/api';

export default {
  name: 'AlternativeLocation',
  components: {
    CustomCallout,
  },
  props: {
    assistantId: {
      type: Number,
      required: true,
    },
    schoolId: {
      type: Number,
      required: true,
    },
    academicYearId: {
      type: [Number, String],
      default: 0,
    },
  },
  data() {
    return {
      alternativeLocationList: [],
    };
  },
  methods: {
    async fetchAlternativeLocations() {
      const params = {
        assistantId: this.assistantId,
        schoolId: this.schoolId,
        academicYearId: this.academicYearId,
        pageIndex: 1,
        pageSize: 100,
      };

      const { data: result } = await getSchoolAlternativeLocations(params);
      this.alternativeLocationList = result.data.map((item) => ({
        category: (item.category && item.category.name) || '-',
        alternative: (item.alternative && item.alternative.name) || '-',
        teacher: (item.teacher && item.teacher.name) || '-',
      }));
    },
  },
  async mounted() {
    await this.fetchAlternativeLocations();
  },
};
</script>

<style scoped>
.box-result-field-value {
  font-weight: bold;
}
</style>
